import { createApiClient } from '@hpd/contract';

import { accessToken } from './auth/cognito.ts';
import { env } from './env.ts';

// The one client for the whole app (CB-CONV §7: no hand-written fetch calls). The token is fetched
// per request rather than captured once, so Amplify's refresh is picked up without the app holding
// a token itself — which is also why nothing here writes to localStorage.

export const api = createApiClient({ baseUrl: env.apiBaseUrl, token: accessToken });
